<template>
    <div class="entry-content">
        <h2>Information</h2>
        <form @submit.prevent="handleFormSubmit">
            <input type="text" v-model="name" placeholder="Course Name" maxlength="400" required>
            <textarea name="description" id="descr" cols="10" rows="17" placeholder="Course Description" maxlength="400" v-model="description" required/>
            <div class="form-footer-wrapper">
                <button type="button" class="cancel" @click.prevent="handleRedirect">Cancel</button>
                <input type="submit" class="save" value="Add" />
            </div>
        </form>
    </div>
</template>

<script>
import CheckApi from '@/api';

export default {
    props: [],
    name: 'AddCourse',
    components: {},
    data() {
		return {
            name: '',
            description: ''
        }
    },
    methods: {
        async handleFormSubmit() {
            CheckApi.createCourseTemplate({name: this.name, description: this.description})
        },
        handleRedirect() {
            this.$router.push('/templates?page=1')
        }
    }
}
</script>

<style lang="scss" scoped>

    .form-footer-wrapper {
        display: flex;
        justify-content: flex-end;
    }

    .cancel {
        background-color: transparent;
        border: .0625em solid #141638;

        &:hover {
            color: #141638;
        }
    }

    .cancel,
    .save {
        width: 100px !important;
        height: 30px !important;
        border-radius: .75em !important;
        text-align: center !important;
        cursor: pointer;
    }

    .save {
        margin-left: 15px;
        background-color: #08ce97;
        border-style: none;
        color: #fff;
        border-radius: 0.75em;
        display: block !important;
        margin: 0 !important;
        margin-left: 15px !important;
        padding: 5px;
    }
</style>